import React from "react";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <main className="terms-page" aria-labelledby="terms-title">
      <section className="terms-hero">
        <div className="terms-container">
          <nav className="terms-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Terms &amp; Conditions</span>
          </nav>

          <p className="terms-eyebrow">Auditus-iERP</p>
          <h1 id="terms-title">Auditus-iERP Terms and Conditions</h1>
          <p className="terms-updated">Last Updated: September 4, 2026</p>
        </div>
      </section>

      <section className="terms-content">
        <div className="terms-container terms-document">
          <article>
            <h2>1. Introduction</h2>
            <p>These Terms and Conditions govern your access to and use of Auditus-iERP, business management software represented by Auditus IERP at https://auditusierp.com.</p>
          </article>
          <article>
            <h2>2. Acceptance of Terms</h2>
            <p>By using Auditus-iERP, requesting a demo, downloading software, or using related services, you agree to these Terms. If you do not agree, you should not use the software or related services.</p>
          </article>
          <article>
            <h2>3. Description of Auditus-iERP</h2>
            <p>Auditus-iERP is business management software for workflows such as ERP, billing, accounting, inventory, POS, GST, sales, purchases, customers, suppliers, payments, and reports.</p>
          </article>
          <article>
            <h2>4. Eligibility and Authority to Use the Software</h2>
            <p>You are responsible for ensuring that you have authority to use Auditus-iERP for your business or organization and to provide any information entered into the software.</p>
          </article>
          <article>
            <h2>5. Account and Access Responsibilities</h2>
            <p>You are responsible for maintaining the confidentiality of your account, device, login credentials, and user access permissions. You should notify us if you believe your access has been misused.</p>
          </article>
          <article>
            <h2>6. User Responsibilities</h2>
            <p>You agree to use Auditus-iERP lawfully, keep information you enter accurate, review business records before relying on them, and comply with applicable tax, accounting, privacy, and business requirements.</p>
          </article>
          <article>
            <h2>7. Business Data and User Content</h2>
            <p>You remain responsible for business data, customer information, product details, invoices, reports, files, messages, and other content entered, imported, generated, or sent using Auditus-iERP.</p>
          </article>
          <article>
            <h2>8. Google/Gmail Integration</h2>
            <p>Gmail integration is optional and requires authorization from the Google account user. Auditus-iERP does not claim unrestricted Gmail access and depends on the permissions granted by the user.</p>
          </article>
          <article>
            <h2>9. Email Sending Functionality</h2>
            <p>Auditus-iERP may use the Gmail API permission <code>https://www.googleapis.com/auth/gmail.send</code> to send emails through the Gmail account authorized by the user. Users are responsible for email recipients, content, attachments, and compliance with applicable communication rules.</p>
          </article>
          <article>
            <h2>10. Third-Party Services</h2>
            <p>Certain functionality may depend on third-party services such as Google APIs, browsers, devices, operating systems, internet connectivity, or other services selected or authorized by the user.</p>
          </article>
          <article>
            <h2>11. Software License / Permitted Use</h2>
            <p>Subject to these Terms, you may use Auditus-iERP for your internal business operations. You may not copy, resell, reverse engineer, or misuse the software except where permitted by applicable law.</p>
          </article>
          <article>
            <h2>12. Prohibited Uses</h2>
            <p>You must not use Auditus-iERP to:</p>
            <ul>
              <li>Violate laws, regulations, or third-party rights.</li>
              <li>Send unlawful, deceptive, abusive, or unauthorized communications.</li>
              <li>Attempt to gain unauthorized access to systems or data.</li>
              <li>Interfere with the security or operation of the software.</li>
              <li>Use Google or Gmail permissions beyond user-authorized purposes.</li>
            </ul>
          </article>
          <article>
            <h2>13. Intellectual Property</h2>
            <p>Auditus-iERP, its website, software, branding, interface, content, and related materials are owned by Auditus IERP or its licensors. These Terms do not transfer ownership rights to users.</p>
          </article>
          <article>
            <h2>14. Data and Backup Responsibilities</h2>
            <p>You are responsible for reviewing, exporting, backing up, and preserving business records as appropriate for your organization. Auditus-iERP should not be treated as a substitute for your own legal, accounting, tax, or backup obligations.</p>
          </article>
          <article>
            <h2>15. Availability and Changes to the Service</h2>
            <p>We may update, change, suspend, or discontinue parts of Auditus-iERP or related services from time to time. Some features may depend on device, network, operating system, third-party service, or authorization status.</p>
          </article>
          <article>
            <h2>16. Security Responsibilities</h2>
            <p>You are responsible for keeping your devices, accounts, passwords, Google account, and user permissions secure. You should revoke access or contact us if you believe an account or integration is no longer authorized.</p>
          </article>
          <article>
            <h2>17. Disclaimers</h2>
            <p>Auditus-iERP is provided for business management purposes. We do not provide legal, tax, accounting, or financial advice. You should review outputs, reports, filings, and messages before relying on or submitting them.</p>
          </article>
          <article>
            <h2>18. Limitation of Liability</h2>
            <p>To the extent permitted by applicable law, Auditus IERP will not be liable for indirect, incidental, special, consequential, or punitive damages, or for loss of profits, data, goodwill, or business opportunity.</p>
          </article>
          <article>
            <h2>19. Indemnification</h2>
            <p>You agree to be responsible for claims, losses, liabilities, damages, and expenses arising from your misuse of Auditus-iERP, violation of these Terms, unlawful content, or unauthorized use of third-party services.</p>
          </article>
          <article>
            <h2>20. Termination</h2>
            <p>We may suspend or terminate access where required to protect the software, other users, legal compliance, or our rights. You may stop using the software and may revoke Google access through your Google Account security settings.</p>
          </article>
          <article>
            <h2>21. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. When changes are made, the updated Terms will be posted on this page with a revised Last Updated date.</p>
          </article>
          <article>
            <h2>22. Governing Law / Jurisdiction</h2>
            <p>These Terms are intended to be governed by applicable law. Because no specific jurisdiction was confirmed in the website source, this section should be reviewed by Auditus IERP before production legal use.</p>
          </article>
          <article>
            <h2>Contact</h2>
            <p>
              <strong>Auditus IERP</strong>
              <br />
              Website: <a href="https://auditusierp.com">https://auditusierp.com</a>
              <br />
              Email: <a href="mailto:auditusierp@gmail.com">auditusierp@gmail.com</a>
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}
